import { render, staticRenderFns } from "./ChannelAccount.vue?vue&type=template&id=832c8182&scoped=true&"
import script from "./ChannelAccount.vue?vue&type=script&lang=js&"
export * from "./ChannelAccount.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAccount.vue?vue&type=style&index=0&id=832c8182&lang=less&scoped=true&"
import style1 from "./ChannelAccount.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832c8182",
  null
  
)

export default component.exports